import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Button } from '@mui/material';

const Resources = () => {
  const { t } = useTranslation();

  return (
    <div>
     

      {/* Resources section */}
<Box component="main" sx={{ p: 4, textAlign: 'center' }}>
  <Typography
    variant="h3"
    sx={{
      fontSize: { xs: '2rem', md: '2.5rem' },
      mt: -2,
      mb: 4,
    }}
  >
    {t('resources.title', 'Resources')}
  </Typography>

  {/* Two YouTube Videos Side by Side with Responsive Aspect Ratio */}
  <Box
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      justifyContent: 'center',
      alignItems: 'center',
      gap: 4,
    }}
  >
    <Box
      component="iframe"
      src="https://www.youtube.com/embed/Uzz0C96Eav0"
      title="YouTube video player 1"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      sx={{
        width: '100%',
        maxWidth: '500px',
        aspectRatio: '16 / 9',
        border: 0,
      }}
    />
    <Box
      component="iframe"
      src="https://www.youtube.com/embed/56Hokp3Y6Yw"
      title="YouTube video player 2"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      sx={{
        width: '100%',
        maxWidth: '500px',
        aspectRatio: '16 / 9',
        border: 0,
      }}
    />
              <Box
            component="iframe"
            src="https://www.youtube.com/embed/fEPMy9uSMHI" // Replace with your 3rd video ID
            title="YouTube video player 3"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            sx={{
              width: '100%',
              maxWidth: '500px',
              aspectRatio: '16 / 9',
              border: 0,
            }}
          />
  </Box>
</Box>


      {/* Toolkit Section */}
<Box
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    height: { xs: 'auto', md: '400px' },
    overflowX: 'hidden',
  }}
>
  {/* Left Column (Image) */}
<Box
  sx={{
    width: { xs: '100%', md: '50%' },
    height: { xs: '300px', md: 'auto' },
    boxSizing: 'border-box',
    position: 'relative',
    overflow: 'hidden',
  }}
>
  {/* Image */}
  <Box
    component="img"
    src={`${process.env.PUBLIC_URL}/images/resources-toolkit.jpg`}
    alt={t('resources.toolkit_image_alt', 'Toolkit')}
    sx={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    }}
  />

  {/* Dark overlay */}
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // You can tweak this opacity
    }}
  />
</Box>


  {/* Right Column (Text) */}
  <Box
    sx={{
      width: { xs: '100%', md: '50%' },
      bgcolor: '#ffb606',
      color: 'black',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
    }}
  >
    <Box
      sx={{
        width: '100%',
        px: { xs: 2, sm: 4 },
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        boxSizing: 'border-box',
        maxWidth: '100%',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: '2rem', md: '2.5rem' },
          mt: -2,
          mb: 4,
        }}
      >
        {t('resources.toolkit_title', 'Get Involved')}
      </Typography>

      <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
        {t(
          'resources.toolkit_text'  )}
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: 'black',
            color: 'white',
            '&:hover': { backgroundColor: '#333' },
          }}
        >
          {t('resources.toolkit_button', 'Download Toolkit')}
        </Button>
      </Box>
    </Box>
  </Box>
</Box>

{/* More Resources Section */}
<Box
  sx={{
    position: 'relative',
    width: '100%',
    height: { xs: 'auto', md: '50vh' },
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    
    py: { xs: 2, md: 0 },
    flexDirection: 'column',
    maxWidth: '100vw'
  }}
>
  {/* Background image as <img> */}
  <Box
    component="img"
    src={`${process.env.PUBLIC_URL}/images/resources-bg.jpg`}
    alt="Resources background"
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      zIndex: 0,
    }}
  />

  {/* Dark overlay */}
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 1,
    }}
  />

  {/* Content */}
<Box
  sx={{
    position: 'relative',
    zIndex: 2,
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 3,
    maxWidth: '100%', // constrain content to page width
    width: '100%',
    px: 2,
    boxSizing: 'border-box', // ensure padding doesn't overflow
  }}
>

    <Typography variant="h3" sx={{ fontSize: { xs: '2rem', md: '2.5rem' } }}>
      {t('resources.more_title', 'More Resources')}
    </Typography>
<Typography
  variant="body1"
  sx={{
    fontSize: { xs: '1rem', md: '1.25rem' },
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    maxWidth: '100%',
    px: { xs: 2, sm: 4, md: 8 }, // add horizontal padding for safety
    textAlign: 'center', // ensure text is visually centered
  }}
>
  {t(
    'resources.more_text'  )}
</Typography>

    <Button
      variant="contained"
      onClick={() => window.open('https://vzfla.com/', '_blank')}
      sx={{
        backgroundColor: '#FDB51F',
        color: 'black',
        fontWeight: 'bold',
        '&:hover': { backgroundColor: '#e0a519' },
      }}
    >
      {t('resources.more_button', 'Vision Zero Florida')}
    </Button>
  </Box>
</Box>

    {/* Nacto Section */}
<Box
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    height: { xs: 'auto', md: '400px' },
    overflowX: 'hidden',
  }}
>
  {/* Left Column (Text) */}
  <Box
    sx={{
      width: { xs: '100%', md: '50%' },
      boxSizing: 'border-box',
      bgcolor: '#fff',
      color: 'black',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box
      sx={{
        width: '100%',
        px: { xs: 2, sm: 4 },
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        boxSizing: 'border-box',
        maxWidth: '100%',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: '2rem', md: '2.5rem' },
          mt: -2,
          mb: 4,
        }}
      >
        {t('resources.nacto_title', 'National Association of City Transportation Officials')}
      </Typography>

      <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
        {t('resources.nacto_text')}
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
        <Button
          variant="contained"
          onClick={() => window.open('https://nacto.org/', '_blank')}
          sx={{
            backgroundColor: 'black',
            color: 'white',
            '&:hover': { backgroundColor: '#333' },
          }}
        >
          {t('resources.nacto_button', 'Public Input')}
        </Button>
      </Box>
    </Box>
  </Box>

  {/* Right Column (Image) */}
<Box
  sx={{
    width: { xs: '100%', md: '50%' },
    height: { xs: '300px', md: 'auto' },
    boxSizing: 'border-box',
    position: 'relative',
    overflow: 'hidden',
  }}
>
  {/* Image */}
  <Box
    component="img"
    src={`${process.env.PUBLIC_URL}/images/resources-nacto.jpg`}
    alt={t('resources.nacto_image_alt', 'Nacto')}
    sx={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    }}
  />

  {/* Dark overlay */}
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // Adjust opacity if needed
    }}
  />
</Box>

</Box>

      {/* Network Section */}
<Box
  sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    height: { xs: 'auto', md: '400px' },
    overflowX: 'hidden',
  }}
>
  {/* Left Column (Image) */}
<Box
  sx={{
    width: { xs: '100%', md: '50%' },
    height: { xs: '300px', md: 'auto' },
    boxSizing: 'border-box',
    position: 'relative',
    overflow: 'hidden',
  }}
>
  {/* Image */}
  <Box
    component="img"
    src={`${process.env.PUBLIC_URL}/images/resources-network.jpg`}
    alt={t('resources.network_image_alt', 'Network')}
    sx={{
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    }}
  />

  {/* Dark overlay */}
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.4)', // Adjust for darker or lighter overlay
    }}
  />
</Box>


  {/* Right Column (Text) */}
  <Box
    sx={{
      width: { xs: '100%', md: '50%' },
      bgcolor: '#ffb606',
      color: 'black',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
    }}
  >
    <Box
      sx={{
        width: '100%',
        px: { xs: 2, sm: 4 },
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 2,
        boxSizing: 'border-box',
        maxWidth: '100%',
      }}
    >
      <Typography
        variant="h3"
        sx={{
          fontSize: { xs: '2rem', md: '2.5rem' },
          mt: -2,
          mb: 4,
        }}
      >
        {t('resources.network_title', 'Vision Zero Network')}
      </Typography>

      <Typography variant="body1" sx={{ fontSize: { xs: '1.1rem', md: '1.25rem' } }}>
        {t(
          'resources.network_text'  )}
      </Typography>

      <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' } }}>
        <Button
          variant="contained"
          onClick={() => window.open('https://visionzeronetwork.org/', '_blank')}
          sx={{
            backgroundColor: 'black',
            color: 'white',
            '&:hover': { backgroundColor: '#333' },
          }}
        >
          {t('resources.network_button', 'Vision Zero Network')}
        </Button>
      </Box>
    </Box>
  </Box>
</Box>




    </div>
  );
};

export default Resources;
